import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { FormGuard } from 'src/app/shared/guards/form.guard';

import { AccountComponent } from './account.component';
import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';
import { SiteDetailPageComponent } from './site-detail-page/site-detail-page.component';

import { AuthGuard } from '../../core/auth/auth.guard';
import { VerifiedGuard } from '../../core/auth/verified.guard';
import { SharedModule } from '../../shared';
import { UserActivityDashboardComponent } from '../../shared/components/activity-dashboard/user-activity-dashboard.component';
import { DisturbanceReportComponent } from '../../shared/components/disturbance-report/disturbance-report.component';
import { PeriodicReportComponent } from '../../shared/components/periodic-report/periodic-report.component';
import { ProfilePageComponent } from '../../shared/components/profile-page/profile-page.component';
import { ReportResponseComponent } from '../../shared/components/report-response/report-response.component';
import { VerifyAccountComponent } from '../../shared/components/verify-account-page/verify-account.component';
import { RoleEnum } from '../../shared/constants/role.enums';

const routes: Routes = [
  {
    path: '',
    component: AccountComponent,
    canActivate: [AuthGuard],
    data: { roles: [RoleEnum.Landowner] },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        component: DashboardPageComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [RoleEnum.Landowner],
        },
      },
      {
        path: 'profile',
        component: ProfilePageComponent,
        canActivate: [VerifiedGuard, AuthGuard],
        data: {
          roles: [RoleEnum.Landowner],
          verified: true,
        },
        canDeactivate: [FormGuard],
      },
      {
        path: 'profile/activity',
        component: UserActivityDashboardComponent,
        canActivate: [VerifiedGuard, AuthGuard],
        data: {
          roles: [RoleEnum.Landowner],
          verified: true,
        },
        canDeactivate: [FormGuard],
      },
      {
        path: 'site/:id',
        component: SiteDetailPageComponent,
        canActivate: [AuthGuard],
        data: { roles: [RoleEnum.Landowner] },
      },
      {
        path: 'site/:id/periodic-report',
        component: PeriodicReportComponent,
        canActivate: [AuthGuard],
        data: { roles: [RoleEnum.Landowner] },
        canDeactivate: [FormGuard],
      },
      {
        path: 'site/:id/report-response/:reportId',
        component: ReportResponseComponent,
        canActivate: [AuthGuard],
        data: { roles: [RoleEnum.Landowner] },
      },
      {
        path: 'site/:id/report-response',
        component: ReportResponseComponent,
        canActivate: [AuthGuard],
        data: { roles: [RoleEnum.Landowner] },
      },
      {
        path: 'site/:id/disturbance-report',
        component: DisturbanceReportComponent,
        canActivate: [AuthGuard],
        data: { roles: [RoleEnum.Landowner] },
        canDeactivate: [FormGuard],
      },
      {
        path: 'site/:id/periodic-report/:reportId',
        component: PeriodicReportComponent,
        canActivate: [AuthGuard],
        data: { roles: [RoleEnum.Landowner] },
      },
      {
        path: 'site/:id/disturbance-report/:reportId',
        component: DisturbanceReportComponent,
        canActivate: [AuthGuard],
        data: { roles: [RoleEnum.Landowner] },
      },
      {
        path: 'verify',
        component: VerifyAccountComponent,
        canActivate: [AuthGuard],
        data: { roles: [RoleEnum.Landowner] },
        canDeactivate: [FormGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), SharedModule],
  exports: [RouterModule],
})
export class AccountRoutingModule {}
